import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Notification } from '@telus-uds/components-web';

import request from '../../../../../../../utils/request';
import { useLocalizedStringsContext } from '../../../../../../../context/LocalizedStringsContext';

const AddBan = ({ orderData, userRights }) => {
  const { canAssignOrder } = userRights;
  const { id, iotCurrentBan, iotTelusAccountNumber } = orderData;
  const {
    iotOrderDetailsSection: { placeholderAddBan, messageBanUpdated },
    ORDERS: { assign, save, cancel }
  } = useLocalizedStringsContext();

  const [ban, setBan] = useState();
  const [changeBan, setChangeBan] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const updateBan = async () => {
    try {
      setChangeBan(false);
      setUpdating(true);
      const result = await request.put(`/orders/${id}`, {
        iotCurrentBan: ban,
        iotTelusAccountNumber: ban
      });
      if (result) {
        setUpdating(false);
        setShowSuccess(true);
      }
    } catch (error) {
      setUpdating(false);
      setShowSuccess(false);
    }
  };

  useEffect(() => {
    if (iotTelusAccountNumber) setBan(iotTelusAccountNumber);
    else if (iotCurrentBan) setBan(iotCurrentBan);
  }, []);

  return (
    <div style={{ padding: '0 0.75rem' }}>
      {updating ? (
        <p>Updating...</p>
      ) : (
        <>
          {changeBan ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                style={{ margin: '0.5rem 0', borderColor: '#222', width:'50%' }}
                type="text"
                placeholder={placeholderAddBan}
                value={ban}
                onChange={e => setBan(e.target.value)}
              />
              <div
                style={{
                  display: 'flex',
                  gap: '0.5rem',
                  marginLeft: '0.5rem',
                  alignItems: 'center'
                
                }}
              >
                <Button variant={{ text: true }} onPress={() => updateBan()}>{save}</Button>
                <span>|</span>
                <Button variant={{ text: true }}
                  onPress={() => {
                    setBan(iotCurrentBan);
                    setChangeBan(false);
                  }}
                >
                  {cancel}
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  gap: '1rem'
                }}
              >
                <p>{ban || 'n/a'}</p>
                {canAssignOrder && (
                  <Button variant={{ text: true }} onPress={() => setChangeBan(true)}>
                    {assign}
                  </Button>
                )}
              </div>
              {showSuccess && (
                <Notification
                  variant={{ style: 'success' }}
                  dismissible
                  onExit={() => setShowSuccess(false)}
                  copy="en"
                >
                  {messageBanUpdated}
                </Notification>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

AddBan.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  userRights: PropTypes.objectOf(PropTypes.object).isRequired
};

export default AddBan;
